import './Header.css'
import Navbar from './Navbar';


function Header(){
    return(
        <header className='Header-container'>
                <h1 className='business-name'>TANA'S FRUIT ARRANGEMENTS</h1>
                <h3 className='slogan'>Dont just dream it, enjoy it!</h3>

                <Navbar></Navbar>
        </header>
    )
}

export default Header